import React from "react";
import qualityImg from "../../assets/Images/home/quality.svg";
import fastDeliveryImg from "../../assets/Images/home/fast-delivery.svg";
import satisfactionImg from "../../assets/Images/home/satisfaction.svg";
import healthNeedsImg from "../../assets/Images/home/health-needs.svg";
import supportImg from "../../assets/Images/home/support.svg";
import nIconLogoImg from "../../assets/Images/home/n-icon-logo.svg";
import doubleArrowImg from "../../assets/Images/home/double-arrow.svg";

export default function PartnerWithNutralike() {
  const features = [
    {
      icon: qualityImg,
      text: "QUALITY THAT DEFINES TRUST – OUR PROMISE.",
    },
    {
      icon: fastDeliveryImg,
      text: "FAST DELIVERY WITHOUT COMPROMISING QUALITY.",
    },
    {
      icon: satisfactionImg,
      text: "YOUR SATISFACTION, OUR TOP PRIORITY.",
    },
    {
      icon: healthNeedsImg,
      text: "CUTTING-EDGE FORMULATIONS FOR MODERN HEALTH NEEDS.",
    },
    {
      icon: supportImg,
      text: "DEDICATED SUPPORT – FROM CONCEPT TO COMPLETION.",
    },
  ];

  return (
    <section className="w-full bg-[#F2F6EF] py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left Section */}
          <div className="flex flex-col items-center text-center">
            {/* Logo Icon */}
            <div className="mb-4 md:mb-6">
              <div className="relative w-16 h-16   md:w-20 md:h-20">
              <div className="shine">
                  <img 
                  src={nIconLogoImg}
                  alt="Private Label Nutralike"
                  className="w-full h-full object-contain"
                />
              </div>
              </div>
            </div>

            {/* Heading */}
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-5xl font-serif text-[#355931]">
              Partner With Nutralike <span className="gradient-text"> For Your Private Label Success
              </span>
            </h2>

            {/* Description */}
            <p className="text-[#335235] text-sm md:text-base leading-relaxed max-w-lg">
              Partnering with Nutralike means choosing innovation, reliability, and a team
              that understands your business. We deliver customized nutraceutical solutions
              that reflect your brand identity – backed by quality, speed, and excellence.
            </p>
          </div>

          {/* Right Section */}
          <div className="flex flex-col border border-[#7B9E43] p-6 border-3  rounded-3xl">
            {/* Right Heading */}
            <h3 className="text-3xl text-center sm:text-4xl md:text-5xl lg:text-3xl font-serif text-[#355931] leading-tight mb-5">
              WHY CHOOSE NUTRALIKE FOR <span className="gradient-text">PRIVATE LABELING?</span> 
            </h3>

            {/* Feature Cards */}
            <div className="flex flex-col gap-3">
              {features.map((feature, index) => (
  <div key={index} className="flex items-center gap-3 md:gap-4">
    
    {/* OUTSIDE ICON */}
    <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12  flex items-center justify-center ">
      {feature.icon ? (
        <div className="shine">
          <img
            src={feature.icon}
            alt=""
            className="w-6 h-6 md:w-9 md:h-9 object-contain"
          />
        </div>
      ) : (
        <div className="w-5 h-5 md:w-6 md:h-6 rounded-full bg-[#335235] opacity-30"></div>
      )}
    </div>

    {/* CARD */}
    <div className="flex items-center gap-3 md:gap-4 bg-gradient-to-r from-[#5A7D3A] to-[#7CB342] rounded-lg p-2 md:p-2 shadow-md hover:shadow-lg transition-all duration-300 flex-1">
      
      {/* Arrow INSIDE */}
      <div className="flex-shrink-0">
        <div className="shine">
          <img 
            src={doubleArrowImg}
            alt="arrow" 
            className="w-4 h-4 md:w-5 md:h-5"
          />
        </div>
      </div>

      {/* Text */}
      <p className="text-white font-semibold text-xs sm:text-sm md:text-base leading-tight flex-1">
        {feature.text}
      </p>
    </div>

  </div>
))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}